// extracted by mini-css-extract-plugin
export default {"item":"TodoAccount_item__RAt8z","strike":"TodoAccount_strike__2wHwM","remove":"TodoAccount_remove__sHQEn","done":"TodoAccount_done__IYhBJ"};